<div class="card">
  <div class="container2 mb-5">
    <select-filter
      #selectFilter
      (check)="changedCheckbox2($event)"
    ></select-filter>
    <div class="row" cdkDropListGroup>
      <div class="col-6 mb-5" style="padding-top: 23px">
        <button
          class="button"
          (click)="openDialog()"
          *ngIf="permisosStr.includes('Administrador de Casos')"
        >
          Crear {{ text.Caso }}
        </button>
        <button
          class="button ml-2"
          routerLink="../../../casos/casosArchivados"
          *ngIf="permisosStr.includes('Administrador de Casos')"
        >
          Ver {{ text.casos }} archivados
        </button>
        <!-- (click)="openCasosArchivados()" -->
        <button
          class="button ml-2"
          routerLink="../../revision"
          *ngIf="
            permisosStr.includes('Administrador de Casos') &&
            valueCase !== 'fraudes'
          "
        >
          {{ text.Casos }} por aprobar
        </button>
        <!-- <deteccion-fraude-boton-aprobar-caso></deteccion-fraude-boton-aprobar-caso> -->
      </div>
      <div class="col-6 mb-3">
        <div class="d-flex justify-content-center h-100">
          <div class="searchbar">
            <input
              class="search_input"
              type="text"
              [(ngModel)]="search"
              placeholder="Filtrar..."
            />
            <button class="search_icon" (click)="filter()">
              <i class="fas fa-search"></i>
            </button>
          </div>
        </div>
      </div>

      <div
        class="mb-4 tarea"
        [ngClass]="valueCase != 'externos' ? 'col-3' : 'col-4'"
        cdkDropList
        [cdkDropListData]="PorAsignar"
        (cdkDropListDropped)="drop($event, 'Por Asignar')"
      >
        <div class="tarea">
          <div class="tarea-header" style="background-color: #eeeeee">
            <div class="row" style="display: flex">
              <p class="tarea-titulo col-10">Sin Comenzar ({{ porasignar }})</p>
              <div
                style="display: flex; margin: 10px 0px 0px -66px"
                *ngIf="allCasos"
              >
                <div *ngFor="let elem of allCasos[0]; let i = index">
                  <div
                    class="istyle"
                    *ngIf="actualFilter[i]"
                    [ngStyle]="{ background: actualFilter[i].color }"
                  >
                    {{
                      elem.casos.porasignar.length == undefined
                        ? 0
                        : elem.casos.porasignar.length
                    }}
                  </div>
                </div>
              </div>

              <!--
                <div class="istyle" > {{inallCasostPA}}  </div>
                <div class="rstyle"> {{retPA}} </div>
                <div  class="gstyle">{{grupPA}} </div> -->
            </div>
          </div>
          <div class="tarea-text">
            <div *ngFor="let caso of PorAsignar" class="card" cdkDrag>
              <div
                class="card-header"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <button
                  matTooltip="Editar el caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  (click)="editar(caso)"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                >
                  <mat-icon style="font-size: 15px">edit</mat-icon>
                </button>
                <button
                  matTooltip="Ver detalles del caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  [routerLink]="'../../detalle/' + caso._id"
                  *ngIf="
                    permisosStr.includes('Administrador de Casos') ||
                    caso.asignadoA === correo_usuario
                  "
                >
                  <mat-icon style="font-size: 15px">visibility</mat-icon>
                </button>
                <button
                  matTooltip="Cambiar de columna"
                  style="float: right; background: rgba(0, 0, 0, 0) !important"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                >
                  <mat-icon style="font-size: 15px"> arrow_forward </mat-icon>
                </button>
              </div>
              <div
                class="card-body cardh"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <p>
                  <b>Número de {{ text.caso }}:</b> {{ caso.numero_caso }}
                </p>
                <p>
                  <b>Analista:</b> {{ caso.asignadoA }}
                  <span *ngIf="!caso.asignadoA">Sin Asignar</span>
                </p>
                <p><b>Unidad:</b> {{ caso.unidad }}</p>
                <p>
                  <b>Tipo de {{ text.caso }}:</b> {{ caso.tipo_caso }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mb-4 tarea"
        [ngClass]="valueCase != 'externos' ? 'col-3' : 'col-4'"
        cdkDropList
        [cdkDropListData]="EnEjecucion"
        (cdkDropListDropped)="drop($event, 'En Ejecución')"
      >
        <div class="tarea">
          <div class="tarea-header" style="background-color: #eeeeee">
            <div class="row">
              <p class="tarea-titulo col-10">En Ejecución ({{ ejecucio }})</p>
              <div
                style="display: flex; margin: 10px 0px 0px -66px"
                *ngIf="allCasos"
              >
                <div *ngFor="let elem of allCasos[0]; let i = index">
                  <div
                    class="istyle"
                    *ngIf="actualFilter[i]"
                    [ngStyle]="{ background: actualFilter[i].color }"
                  >
                    {{
                      elem.casos.ejecucio.length == undefined
                        ? 0
                        : elem.casos.ejecucio.length
                    }}
                  </div>
                </div>
              </div>
              <!-- <div class="istyle" > {{intE}}  </div>
              <div class="rstyle"> {{retE}} </div>
              <div  class="gstyle">{{grupE}} </div> -->
            </div>
          </div>
          <div class="tarea-text">
            <div *ngFor="let caso of EnEjecucion" class="card" cdkDrag>
              <div
                class="card-header"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <button
                  matTooltip="Editar el caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                  (click)="editar(caso)"
                >
                  <mat-icon style="font-size: 15px">edit</mat-icon>
                </button>
                <button
                  matTooltip="Ver detalles del caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  [routerLink]="'../../detalle/' + caso._id"
                  *ngIf="
                    permisosStr.includes('Administrador de Casos') ||
                    caso.asignadoA === correo_usuario
                  "
                >
                  <mat-icon style="font-size: 15px">visibility</mat-icon>
                </button>
                <button
                  matTooltip="Cambiar de columna"
                  style="float: right; background: rgba(0, 0, 0, 0) !important"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                >
                  <mat-icon style="font-size: 15px"> arrow_forward </mat-icon>
                </button>
              </div>
              <div
                class="card-body cardh"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <p>
                  <b>Número de {{ text.caso }}:</b> {{ caso.numero_caso }}
                </p>
                <p><b>Analista:</b> {{ caso.asignadoA }}</p>
                <p><b>Unidad:</b> {{ caso.unidad }}</p>
                <p>
                  <b>Tipo de {{ text.caso }}:</b> {{ caso.tipo_caso }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="valueCase != 'externos'"
        class="col-3 mb-4 tarea"
        cdkDropList
        [cdkDropListData]="Bloqueado"
        (cdkDropListDropped)="drop($event, 'Bloqueado')"
      >
        <div class="tarea">
          <div class="tarea-header" style="background-color: #eeeeee">
            <div class="row">
              <p class="tarea-titulo col-10">Por Aprobar ({{ bloqueado }})</p>
              <div
                style="display: flex; margin: 10px 0px 0px -66px"
                *ngIf="allCasos"
              >
                <div *ngFor="let elem of allCasos[0]; let i = index">
                  <div
                    class="istyle"
                    *ngIf="actualFilter[i]"
                    [ngStyle]="{ background: actualFilter[i].color }"
                  >
                    {{
                      elem.casos.bloqueado.length == undefined
                        ? 0
                        : elem.casos.bloqueado.length
                    }}
                  </div>
                </div>
              </div>
              <!-- <div class="istyle" > {{intB}}  </div>
              <div class="rstyle"> {{retB}} </div>
              <div  class="gstyle">{{grupB}} </div> -->
            </div>
          </div>
          <div class="tarea-text">
            <div *ngFor="let caso of Bloqueado" class="card" cdkDrag>
              <div
                class="card-header"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <button
                  matTooltip="Editar el caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  (click)="editar(caso)"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                >
                  <mat-icon style="font-size: 15px">edit</mat-icon>
                </button>
                <button
                  matTooltip="Ver detalles del caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  [routerLink]="'../../detalle/' + caso._id"
                  *ngIf="
                    permisosStr.includes('Administrador de Casos') ||
                    caso.asignadoA === correo_usuario
                  "
                >
                  <mat-icon style="font-size: 15px">visibility</mat-icon>
                </button>
                <button
                  matTooltip="Cambiar de columna"
                  style="float: right; background: rgba(0, 0, 0, 0) !important"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                >
                  <mat-icon style="font-size: 15px"> arrow_forward </mat-icon>
                </button>
              </div>
              <div
                class="card-body cardh"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <p>
                  <b>Número de {{ text.caso }}:</b> {{ caso.numero_caso }}
                </p>
                <p><b>Analista:</b> {{ caso.asignadoA }}</p>
                <p><b>Unidad:</b> {{ caso.unidad }}</p>
                <p>
                  <b>Tipo de {{ text.caso }}:</b> {{ caso.tipo_caso }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mb-4 tarea"
        [ngClass]="valueCase != 'externos' ? 'col-3' : 'col-4'"
        cdkDropList
        [cdkDropListData]="Finalizado"
        (cdkDropListDropped)="drop($event, 'Finalizado')"
      >
        <div class="tarea">
          <div class="tarea-header" style="background-color: #eeeeee">
            <div class="row">
              <p class="tarea-titulo col-10">
                Por Finalizar ({{ finalizado }})
              </p>
              <div
                style="display: flex; margin: 10px 0px 0px -66px"
                *ngIf="allCasos"
              >
                <div *ngFor="let elem of allCasos[0]; let i = index">
                  <div
                    class="istyle"
                    *ngIf="actualFilter[i]"
                    [ngStyle]="{ background: actualFilter[i].color }"
                  >
                    {{
                      elem.casos.finalizado.length == undefined
                        ? 0
                        : elem.casos.finalizado.length
                    }}
                  </div>
                </div>
              </div>
              <!-- <div class="istyle" > {{intF}}  </div>
              <div class="rstyle"> {{retF}} </div>
              <div  class="gstyle">{{grupF}} </div> -->
            </div>
          </div>
          <div class="tarea-text">
            <div *ngFor="let caso of Finalizado" class="card" cdkDrag>
              <div
                class="card-header"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <button
                  matTooltip="Editar el caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  (click)="editar(caso)"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                >
                  <mat-icon style="font-size: 15px">edit</mat-icon>
                </button>
                <button
                  matTooltip="Ver detalles del caso"
                  style="background: rgba(0, 0, 0, 0) !important"
                  [routerLink]="'../../detalle/' + caso._id"
                  *ngIf="
                    permisosStr.includes('Administrador de Casos') ||
                    caso.asignadoA === correo_usuario
                  "
                >
                  <mat-icon style="font-size: 15px">visibility</mat-icon>
                </button>
                <button
                  matTooltip="Observación final"
                  (click)="finalizarDelTodo(caso)"
                  *ngIf="permisosStr.includes('Administrador de Casos')"
                  style="float: right; background: rgba(0, 0, 0, 0) !important"
                >
                  <mat-icon style="font-size: 15px"> done </mat-icon>
                </button>
              </div>
              <div
                class="card-body cardh"
                *ngIf="
                  permisosStr.includes('Administrador de Casos') ||
                  caso.asignadoA === correo_usuario
                "
              >
                <p>
                  <b>Número de {{ text.caso }}</b> {{ caso.numero_caso }}
                </p>
                <p><b>Analista:</b> {{ caso.asignadoA }}</p>
                <p><b>Unidad:</b> {{ caso.unidad }}</p>
                <p>
                  <b>Tipo de {{ text.caso }}:</b> {{ caso.tipo_caso }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
